import { Action } from '@ngrx/store';

export enum IndicatorActionTypes {
  SHOW = '[UI] Show indicator',
  HIDE = '[UI] Hide indicator',
  HIDE_ALL = '[UI] Hide ALL indicator',
}

export class ShowIndicator implements Action {
  readonly type = IndicatorActionTypes.SHOW;

  constructor(public payload: string) {}
}

export class HideIndicator implements Action {
  readonly type = IndicatorActionTypes.HIDE;

  constructor(public payload: string) {}
}

export class HideAllIndicator implements Action {
  readonly type = IndicatorActionTypes.HIDE_ALL;

  constructor() {}
}

export type IndicatorActions = ShowIndicator | HideIndicator | HideAllIndicator;
